export const SORT_PARAM_RE = /^[\w-]+:(asc|desc)$/;
